(function () {
  'use strict';

  function init() {
    if (!('IntersectionObserver' in window)) return;

    const root = document.documentElement;
    const mobile = window.matchMedia('(max-width: 767px)');
    const forms = new Map();
    // A submitted inquiry can continue with the newsletter signup step and
    // Shopify's verification page, which render outside the lead form.
    const selector = 'form[data-fm-lead-form], [data-fm-lead-email-signup], .shopify-challenge__container';
    const purchaseSelector = 'form[action$="/cart/add"] button[type="submit"], button.product-card__quick-add-button, button[name="add"], button[name="checkout"], a[href="/checkout"], .shopify-payment-button__button';
    // Depending on the phone's height, the first screen puts the hero buttons
    // or the category heading and cards in the offer's corner.
    const firstScreenSelector = '.shopify-section--video .button_wrapper, .shopify-section--featured-collections .section-stack > .v-stack';
    // Vertical room that bridges the 55px gap between those hero buttons and
    // that heading, so the 44px offer cannot blink between them while scrolling.
    const clearance = 8;
    let updatePending = false;

    function protectedContentOverlaps() {
      if (!mobile.matches) return false;
      const tab = document.getElementById('loox-visitor-level-referral-btn');
      if (!tab) return false;
      const offer = tab.getBoundingClientRect();
      if (!offer.width || !offer.height) return false;
      return Array.from(document.querySelectorAll(purchaseSelector + ', ' + firstScreenSelector)).some(function (control) {
        const rect = control.getBoundingClientRect();
        const style = window.getComputedStyle(control);
        return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' &&
          style.display !== 'none' && rect.left < offer.right && rect.right > offer.left &&
          rect.top - clearance < offer.bottom && rect.bottom + clearance > offer.top;
      });
    }

    function update() {
      for (const form of forms.keys()) {
        if (!form.isConnected) {
          observer.unobserve(form);
          forms.delete(form);
        }
      }
      root.classList.toggle('fm-mobile-lead-form-visible', mobile.matches && Array.from(forms.values()).some(Boolean));
      root.classList.toggle('fm-mobile-purchase-control-overlap', protectedContentOverlaps());
    }

    function scheduleUpdate() {
      if (updatePending) return;
      updatePending = true;
      window.requestAnimationFrame(function () {
        updatePending = false;
        update();
      });
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        forms.set(entry.target, entry.isIntersecting);
      });
      update();
    });

    function observe(form) {
      if (forms.has(form)) return;
      forms.set(form, false);
      observer.observe(form);
    }

    function discover(node) {
      if (node.nodeType !== 1) return;
      if (node.matches(selector)) observe(node);
      node.querySelectorAll(selector).forEach(observe);
    }

    discover(document.body);
    update();
    // The intent-first form mounts after page load; observe its actual form.
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(discover);
      });
      update();
    }).observe(document.body, { childList: true, subtree: true });

    // Visibility keeps the offer's rectangle stable while hidden, avoiding a
    // hide/show loop as a purchase button scrolls through the same corner.
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    if (mobile.addEventListener) mobile.addEventListener('change', update);
    else mobile.addListener(update);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
